// extracted by mini-css-extract-plugin
export default {"header":"CollapsableList__header___CLudo","container":"CollapsableList__container___Ucvi9","collapsed":"CollapsableList__collapsed___BRokm"};